/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router"
import { useUserStore } from '@/store/modules/user.js'
import SkillsTree from "../views/SkillsTree.vue"
import TasksTree from "../views/TasksTree.vue"
import Privacy from "../views/Privacy.vue"
import Admin from "../views/Admin.vue"
import Import from "@/views/Import.vue"
import Home from "@/views/Home.vue"
import SearchUsers from "@/views/SearchUsers.vue"
import JobTasks from "@/views/JobTasks.vue"
import SkillsControl from "@/views/SkillsControl.vue"
import Users from "@/views/Users.vue"
import MyKnolia from "@/views/MyKnolia.vue"
import Management from "@/views/Management.vue"
import SkillCard from "@/views/SkillCard.vue"
import UserActivityControl from "@/views/UserActivityControl.vue"
import Permissions from "@/views/Permissions.vue"
import ManageParticipation from "@/views/ManageParticipation.vue"
import Alerts from "@/views/Alerts.vue"
import UserPotential from "@/views/UserPotential.vue"
import Challenges from "@/views/Challenges.vue"
import { KNOLIA } from "@/knolia"
import { useSearchUsersStore } from "../store/modules/search-users"
import Help from "../views/Help.vue";

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
    children: [
      {
        path: "/import",
        name: "Import",
        component: Import,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },
      {
        path: "/skills-tree",
        name: "SkillsTree",
        component: SkillsTree,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },
      {
        path: "/tasks-tree",
        name: "TasksTree",
        component: TasksTree,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },
      {
        path: "/job-tasks",
        name: "JobTasks",
        component: JobTasks,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },
      {
        path: "/permissions",
        name: "Permissions",
        component: Permissions,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },
      {
        path: "/manage-participation",
        name: "ManageParticipation",
        component: ManageParticipation,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },  
      {
        path: "/alerts",
        name: "Alerts",
        component: Alerts,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          principalNode: "/admin",
        },
      },  
    ],
  },
  {
    path: "/my-knolia",
    name: "MyKnolia",
    component: MyKnolia,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/rating-skills",
    name: "RatingSkills",
    component: SkillsControl,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/my-knolia",
    },
  },
  {
    path: "/validate-skills",
    name: "ValidadeSkills",
    component: SkillsControl,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/skill-card",
    name: "SkillCard",
    component: SkillCard,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/my-knolia",
    },
  },
  {
    path: "/management",
    name: "Management",
    component: Management,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/user-activity-control",
    name: "UserActivityControl",
    component: UserActivityControl,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/management",
    },
  },
  {
    path: "/search-users",
    name: "SearchUsers",
    component: SearchUsers,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/management",
    },
  },
  {
    path: "/user-potential",
    name: "UserPotential",
    component: UserPotential,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/management",
    },
  },
  {
    path: "/challenges",
    name: "Challenges",
    component: Challenges,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      principalNode: "/management",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function CheckForAdmin(adminRequired, next) {
  if (adminRequired && !KNOLIA.isAdmin())
    next("/rating-skills")
}

function CheckForPolicyAcceptance(store, next, to) {
  if (!store.User.policy_accepted && to.path != '/privacy')
    next("/privacy")
}

router.afterEach(() => {
  window.scrollTo(0, 0);
});

router.beforeEach(async (to, from, next) => {
  document.title = "KNOLIA"
  const store = useUserStore()
  const adminRequired = to.matched.some((route) => route.meta.requiresAdmin)
  const searchUsersStore = useSearchUsersStore()

  await store.GetUser()

  CheckForPolicyAcceptance(store, next, to)

  CheckForAdmin(adminRequired, next)

  if(from.params?.goToAttachments) {
    Object.assign(to.params, { goToAttachments: true })
  }

  switch (to.path) {
    case '/':
      let checked = await KNOLIA.CallBackEnd("get", "check-credentials")

      if (checked?.data?.status == 5)
        next("/home")

      break;

    case '/user-activity-control':

      if(store.User?.permissions?.is_admin || store.User?.is_headship && store.User?.permissions?.can_manage_subordinates_activities)
        next();
      else
        next("/management")

      break;

    case '/search-users':

      if(store.User?.permissions?.is_admin || store.User?.permissions?.can_search_users)
        next();
      else
        next("/management")
      
      break;

    default:
      if (to.path == '/validate-skills')
        Object.assign(to.params, { validateSkills: true })

      if (to.path != '/skill-card' && to.path != '/search-users')
        searchUsersStore.ResetHistoryData()

      next()

  }
});

export default router;